import {useEffect, useState} from "react";

const useCheckMobileScreen = (maxWidthPx: number = 768) => {
    const [width, setWidth] = useState(window.innerWidth);
    const handleWindowSizeChange = () => {
            setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    return (width <= maxWidthPx);
}

export default useCheckMobileScreen
